export default __webpack_public_path__ + "static/media/twentyNine.2d68fed7.jpg";